<div class="stage" id="slide0">
    

    <section class="slide flx-dynamic first">
        <div class="w-50 slide-content-col-wrap">
            <div class="slide-content">
                <h2 class="slide-content-title flx-col"><span class="line-inner small">{{ pageName }}</span><span class="line-inner">{{ pageTitle }}</span></h2>
                <div class="slide-content-wrap">
                    <p class="content-txt"><ng-container i18n>martz Sp. z o.o. wraz z dynamicznym rozwojem firmy poszukuje przedsiębiorców, którzy chcieliby wejść w skład naszej sieci dealerskiej.</ng-container><br>
                        <ng-container i18n>Szukasz pomysłu na biznes?</ng-container><br>
                        <ng-container i18n>Chcesz oferować szeroką gamę produktów?</ng-container><br>
                        <ng-container i18n>Interesują Cię wyłącznie produkty najwyższej jakości?</ng-container><br>
                        <ng-container i18n>Posiadasz plac w dobrej lokalizacji?</ng-container>
                    </p>
                </div>
                <div class="flx-dynamic flx-gap-default flx-strt-strt flx-strt-cntr-md">
                    <!-- <a class="flat-button accent" [routerLink]="['/'+path_register]" i18n>Zarejestruj się</a> -->
                    <!-- <a class="flat-button accent scroll-link-href" href="#slide2" i18n="@@contact_us">Skontaktuj się z nami</a> -->
                    <!-- <a class="icon-link accent scroll-link-href" href="#slide1"><span i18n>Poznaj zalety współpracy</span></a> -->
                </div>
            </div>
        </div>
        <div class="w-50 slide-content-col-wrap bggrey">
            <div class="slide-content">
                <h3 class="slide-content-title flx-col"><span class="line-inner" i18n="@@contact_us">Skontaktuj się z nami</span></h3>
                <div class="slide-content-wrap">

                    <div class="content-txt">
                        <form [formGroup]="form" novalidate class="flx-col">
                            <input type="hidden" formControlName="namesurname">
                            <div class="flx-dynamic flx-gap-default">
                                <mat-form-field appearance="outline">
                                    <mat-label i18n="@@email">Adres e-mail</mat-label>
                                    <input matInput formControlName="email" i18n-placeholder>
                                    <mat-error i18n>To pole musi być poprawnym adresem e-mail</mat-error>
                                </mat-form-field>
                                <mat-form-field appearance="outline">
                                <mat-label i18n="@@client_phone">Telefon</mat-label>
                                <input matInput formControlName="phone" i18n-placeholder>
                                <mat-error i18n>To pole musi być poprawnym numerem telefonu</mat-error>
                                </mat-form-field>
                            </div>
                            <div class="flx-dynamic flx-gap-default">
                            <mat-form-field appearance="outline">
                              <mat-label i18n="@@namesurname">Imię i nazwisko</mat-label>
                              <input matInput formControlName="name" i18n-placeholder>
                              <mat-error i18n="@@error_req">To pole jest wymagane</mat-error>
                            </mat-form-field>
                            <mat-form-field appearance="outline">
                              <mat-label i18n="@@cmpn_name">Nazwa firmy</mat-label>
                              <input matInput formControlName="company" i18n-placeholder>
                              <mat-error i18n="@@error_req">To pole jest wymagane</mat-error>
                            </mat-form-field>
                            </div>
                            <div class="flx-dynamic flx-gap-default">
                                <mat-form-field appearance="outline">
                                    <mat-label i18n="@@country">Kraj</mat-label>
                                    <mat-select formControlName="country">
                                    <mat-option *ngFor="let country of countries" [value]="country.value">
                                        {{ country.viewValue }}
                                    </mat-option>
                                    </mat-select>
                                    <mat-error i18n="@@error_req">To pole jest wymagane</mat-error>
                                </mat-form-field>
                                <mat-form-field appearance="outline">
                                  <mat-label i18n="@@postcode">Kod pocztowy</mat-label>
                                  <input matInput formControlName="postcode" i18n-placeholder>
                                </mat-form-field>
                            </div>
                            <mat-form-field appearance="outline">
                              <mat-label i18n>Treść wiadomości</mat-label>
                              <textarea matInput formControlName="message" i18n-placeholder></textarea>
                              <mat-error i18n="@@error_req">To pole jest wymagane</mat-error>
                            </mat-form-field>
                            <div class="rodo-checkbox">
                              <mat-checkbox formControlName="rodo">{{  this.settings.extra_field_2 }} <span (click)="regulations = !regulations" i18n>...czytaj więcej</span></mat-checkbox>
                              <div class="regulations-content" *ngIf="regulations" [innerHtml]="settings.extra_field_3"></div>
                              <mat-error *ngIf="form.controls.rodo.invalid && form.controls.rodo.dirty" i18n>Musisz wyrazić zgodę aby kontynuować</mat-error> 
                            </div>

                            <div class="rodo-checkbox">
                                <mat-checkbox formControlName="newsletter" i18n="@@newsletter">Zapisuję się na newsletter i akceptuję regulamin oraz politykę prywatności. Wyrażam zgodę na przetwarzanie moich danych osobowych przez MARTZ Sp. z o.o. z siedzibą w Świdniku zawartych w wypełnionym formularzu w celach związanych z wysyłką newslettera oraz na kontakt ze mną za pomocą środków komunikacji elektronicznej i z wykorzystaniem podanych przeze mnie danych kontaktowych, w celu marketingu bezpośredniego i w celu przekazywania informacji handlowych.
                                </mat-checkbox>
                            </div>
                      
                          <p class="info error" *ngIf="res === 2" i18n>Nie udało się wysłać wiadomości, spróbuj jeszcze raz.</p>
                          <p class="info success" *ngIf="res === 1" i18n>Twoja wiadomość została wysłana, dziękujemy.</p>
                          <div class="flx-row flx-strt-cntr flx-gap-default">
                            <button class="flat-button primary fat" (click)="submit()"  [disabled]="sent || loading" i18n="@@send">Wyślij wiadomość</button><div *ngIf="loading" class="loader-circle"></div>
                          </div>	
                      </form>
                    </div>
                         
                </div>
            </div>
        </div>
        <!-- <div class="w-50 slide-img-col-wrap">
            <div class="image-wrap">
                <picture>
                    <source srcset="/assets/about/about-img1.webp" type="image/webp">
                    <img class="img" src="/assets/about/about-img1.jpg">
                </picture>
            </div>
        </div> -->
        <a href="#slide1" class="scroll-link scroll-link-href"><svg class="icon icon-chevron-down"><use xlink:href="#icon-chevron-down"></use></svg></a>
    </section>   
    
    <section class="slide flx-dynamic" id="slide1">
        <div class="w-50 slide-content-col-wrap">
            <div class="slide-content">
                <h2 class="slide-content-title flx-col"><span class="line-inner small" i18n>Zalety</span><br /><span class="line-inner" i18n>Współpracy</span></h2>
                <div class="slide-content-wrap">

                    <div class="content-txt">
                        <ul class="blist">
                            <li><b i18n>Szybka realizacja zamówień</b><br><span i18n>Internetowy system B2B pozwala na łatwe i szybkie zamawianie przyczep produkowanych w naszych 2 fabrykach zatrudniących ponad 500 osób.</span></li>
                            <li><b i18n>Bezpieczna dostawę na Twój plac</b><br><span i18n>Przyczepy dostarczamy własną flotą dedykowanych ciężarówek lub we współpracy z firmami transportowymi, na których można polegać.</span></li>
                            <li><b i18n>Dogodne warunki współpracy</b><br><span i18n>W codziennych transakcjach kierujemy się jasnymi zasadami oferując korzystne i stabilne warunki handlowe.</span></li>
                            <li><b i18n>Współpracę z silną marką</b><br><span i18n>Jesteśmy na rynku od 11 lat a nasze przyczepy są jednymi z najczęściej wybieranych produktów przez klientów końcowych.</span></li>
                            <li><b i18n>Wsparcie marketingowe</b><br><span i18n>Możesz liczyć na naszą pomoc w każdym zakresie szeroko pojętego marketingu od strony internetowej poprzez ekspozycję przyczep na Twoim placu.</span></li>
                        </ul>
                    </div>
                         
                </div>
                <!-- <a class="flat-button primary" i18n [routerLink]="['/'+path_register]" i18n>Zarejestruj się</a> -->
                <a class="flat-button primary scroll-link-href" href="#slide2" i18n="@@contact_us">Skontaktuj się z nami</a>
            </div>
        </div>
        <div class="w-50 slide-img-col-wrap">
            <div class="image-wrap">
                <picture>
                    <source srcset="/assets/about/about-img2.webp" type="image/webp">
                    <img class="img" src="/assets/about/about-img2.jpg">
                </picture>
            </div>
        </div>
        <!-- <a href="#slide2" class="scroll-link scroll-link-href"><svg class="icon icon-chevron-down"><use xlink:href="#icon-chevron-down"></use></svg></a> -->
    </section>    

    <!-- <section class="slide flx-dynamic" id="slide2">
        <div class="w-50 slide-content-col-wrap">
            <div class="slide-content">
                <h2 class="slide-content-title flx-col"><span class="line-inner" i18n="@@contact_us">Skontaktuj się z nami</span></h2>
                <div class="slide-content-wrap">

                    <div class="content-txt">
                        <form [formGroup]="form" novalidate class="flx-col">
                            <input type="hidden" formControlName="namesurname">
                            <div class="flx-dynamic flx-gap-default">
                                <mat-form-field appearance="outline">
                                    <mat-label i18n="@@email">Adres e-mail</mat-label>
                                    <input matInput formControlName="email" i18n-placeholder>
                                    <mat-error i18n>To pole musi być poprawnym adresem e-mail</mat-error>
                                </mat-form-field>
                                <mat-form-field appearance="outline">
                                <mat-label i18n="@@client_phone">Telefon</mat-label>
                                <input matInput formControlName="phone" i18n-placeholder>
                                <mat-error i18n>To pole musi być poprawnym numerem telefonu</mat-error>
                                </mat-form-field>
                            </div>
                            <div class="flx-dynamic flx-gap-default">
                            <mat-form-field appearance="outline">
                              <mat-label i18n="@@namesurname">Imię i nazwisko</mat-label>
                              <input matInput formControlName="name" i18n-placeholder>
                              <mat-error i18n="@@error_req">To pole jest wymagane</mat-error>
                            </mat-form-field>
                            <mat-form-field appearance="outline">
                              <mat-label i18n="@@cmpn_name">Nazwa firmy</mat-label>
                              <input matInput formControlName="company" i18n-placeholder>
                              <mat-error i18n="@@error_req">To pole jest wymagane</mat-error>
                            </mat-form-field>
                            </div>
                            <mat-form-field appearance="outline">
                              <mat-label i18n>Treść wiadomości</mat-label>
                              <textarea matInput formControlName="message" i18n-placeholder></textarea>
                              <mat-error i18n="@@error_req">To pole jest wymagane</mat-error>
                            </mat-form-field>
                            <div class="rodo-checkbox">
                              <mat-checkbox formControlName="rodo">{{  this.settings.extra_field_2 }} <span (click)="regulations = !regulations" i18n>...czytaj więcej</span></mat-checkbox>
                              <div class="regulations-content" *ngIf="regulations" [innerHtml]="settings.extra_field_3"></div>
                              <mat-error *ngIf="form.controls.rodo.invalid && form.controls.rodo.dirty" i18n>Musisz wyrazić zgodę aby kontynuować</mat-error> 
                            </div>
                      
                          <p class="info error" *ngIf="res === 2" i18n>Nie udało się wysłać wiadomości, spróbuj jeszcze raz.</p>
                          <p class="info success" *ngIf="res === 1" i18n>Twoja wiadomość została wysłana, dziękujemy.</p>
                          <div class="flx-row flx-strt-cntr flx-gap-default">
                            <button class="flat-button primary fat" (click)="submit()"  [disabled]="sent || loading" i18n>wyślij wiadomość</button><div *ngIf="loading" class="loader-circle"></div>
                          </div>	
                      </form>
                    </div>
                         
                </div>
            </div>
        </div>
        <div class="w-50 slide-img-col-wrap">
            <div class="image-wrap">
                <picture>
                    <source srcset="/assets/about/about-img3.webp" type="image/webp">
                    <img class="img" src="/assets/about/about-img3.jpg">
                </picture>
            </div>
        </div>
        <a href="#slide0" class="scroll-link scroll-link-href"><svg class="icon icon-chevron-up"><use xlink:href="#icon-chevron-up"></use></svg></a>
    </section>     -->
    
</div>